<p-dialog
  [header]="data?.jobNumber"
  [modal]="true"
  [visible]="visible"
  styleClass="bg-gray-100 line-height-1 travel-scheduler-dialog"
  [contentStyle]="{ overflow: 'auto', maxHeight: '70svh' }"
  (visibleChange)="close()"
  [closable]="!isAfterCutoff"
>
  <div class="flex justify-content-between align-items-center flex-wrap gap-2">
    <h3 class="mt-2 mb-0">Build your schedule</h3>
    <dialog-progress
      *ngIf="!isLoading"
      [currentStep]="getCurrentStep()"
      [steps]="getNumberOfSteps()"
    ></dialog-progress>
  </div>

  <div *ngIf="isLoading">
    <p-spinner></p-spinner>
  </div>

  <div *ngIf="!isLoading">
    <div
      *ngIf="
        organisationTypeId === OrganisationTypeEnum.Supplier &&
        taskIndex < tasks.length &&
        taskIndex != -1 &&
        isTaskAlreadyScheduledForTodayLookup[tasks[taskIndex].id]
      "
      class="warning-container my-3"
    >
      <app-warning-container [warningTitle]="'Important Notice'">
        <p>
          This task has already been scheduled for today. You can only choose a different timeslot
          on the same scheduled date.
        </p>
      </app-warning-container>
    </div>

    <schedule-task-sequence
      *ngIf="taskIndex == -1 && data.isFlexible"
      [tasks]="tasks"
    ></schedule-task-sequence>

    <schedule-task
      (scheduleSelected)="handleScheduleSelected($event)"
      [taskIndex]="taskIndex"
      [task]="tasks[taskIndex]"
      *ngIf="taskIndex < tasks.length && taskIndex != -1"
      [previousTaskDropoffWindow]="getPreviousTaskDropoffWindow()"
      [taskCount]="tasks.length"
      [carryoverValidationResult]="getCarryoverValidationResult()"
      (carryoverValidationResultChange)="handleCarryoverValidationResult($event)"
      [jobId]="id"
      [latestHandBackDateTime]="data.latestHandBackDateTime"
      (handedBack)="close()"
      [isAlreadyScheduledForToday]="isTaskAlreadyScheduledForTodayLookup[tasks[taskIndex].id]"
    ></schedule-task>

    <travel-scheduler-summary
      *ngIf="taskIndex == tasks.length"
      [tasks]="tasks"
      (editScheduleClicked)="editSchedule($event)"
      [jobNumber]="data?.jobNumber"
      [evCount]="data.electricVehicleCount"
    ></travel-scheduler-summary>
  </div>

  <p-footer *ngIf="!isLoading">
    <div class="footer-container">
      <div class="footer-price" *ngIf="!isLoading">
        <p class="m-0">You'll get paid</p>
        <h1 class="text-blue-500 mb-0 mt-1">
          {{ data.totalPrice | currency : 'GBP' : 'symbol' : '1.2-2' }}
        </h1>
      </div>
      <div class="footer-buttons">
        <button
          *ngIf="!isAfterCutoff"
          pButton
          label="Cancel"
          class="ui-button-secondary footer-button"
          (click)="close()"
        ></button>
        <button
          pButton
          label="Back"
          [disabled]="backButtonDisabled"
          (click)="back()"
          class="ui-button-secondary footer-button"
        ></button>
        <button
          *ngIf="taskIndex != tasks.length"
          pButton
          label="Continue"
          class="ui-button-primary footer-button"
          [disabled]="isContinueButtonDisabled()"
          [title]="continueBtnTooltip"
          (click)="continue()"
        ></button>
        <button
          *ngIf="taskIndex == tasks.length"
          pButton
          label="Complete"
          class="ui-button-primary footer-button"
          [disabled]="completeDisabled"
          (click)="complete()"
        ></button>
      </div>
    </div>
  </p-footer>
</p-dialog>
